const namespace = 'ListView';

// Set scroll top
export const SET_SCROLL_TOP = `${namespace}/SET_SCROLL_TOP`;

// Loading more events
export const REQUEST_MORE_EVENTS = `${namespace}/REQUEST_MORE_EVENTS`;
export const RECEIVE_MORE_EVENTS = `${namespace}/RECEIVE_MORE_EVENTS`;
